import { Component, OnInit, Input, Output, ViewChild, EventEmitter, Inject } from '@angular/core';
import { ModalDirective } from "ngx-bootstrap";
import { EnvironmentService } from "@nw/ui-core-shared/services";
import { Vehicle } from "../../shared/domain/vehicle";
import { VehicleLiveblockAuctionService } from "../../shared/services/vehicle-liveblock-auction.service";
import { MainStoreService } from '@nw/ui-core-shared/store/main-store.service';

@Component({
  selector: 'nw-liveblock-auction-mobile-view',
  templateUrl: './liveblock-auction-mobile-view.component.html'
})
export class LiveblockAuctionMobileViewComponent implements OnInit {

  @Input() vehicle: Vehicle;
  @Input() showAutobidMobileView: boolean = false;
  @ViewChild('liveblockAuctionMobileViewModal') modal: ModalDirective;
  @Output() initModal: EventEmitter<any> = new EventEmitter();

  buyerOaUrl;
  isiOSDevice = false;

  constructor(private mainStoreService: MainStoreService,
              private environmentService: EnvironmentService) {
    mainStoreService.getStore().select(state => state).subscribe(appMainState => {
      this.isiOSDevice = appMainState.appUiState.isiOSDevice;
    });
  }

  ngOnInit() {
    this.buyerOaUrl = this.environmentService.getEnvironment().interfacePath.buyerOa;
    this.initModal.emit(this.modal);
  }

  navigateToAutobidDesktop(isDesktopView) {
      if (isDesktopView === true) {
        window.open(`${this.buyerOaUrl}/autoBidDetails.html?vehicleId=${this.vehicle.originalVehicleId}`, '_self');
      } else {
        if(this.isiOSDevice) {
          window.location.href = this.environmentService.getEnvironment().interfacePath.appStoreAutobid;
        } else {
          window.location.href = this.environmentService.getEnvironment().interfacePath.googlePlayAutobid;
        }
      }
    this.modal.hide();
    }
}



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/components/autobid-mobile-view/liveblock-auction-mobile-view.component.ts